import React from "react";
import SmartTable from "components/ui_components/table/SmartTable";


const tableColConfig = [
  {
    id: "docOriginalFileName",
    label: "Scanned Req",
  },
];

export default function ScanDocumentsSubTable({ reqId }) {
  return (
    <SmartTable
      resource={`requisitions/${reqId}/docs`}
      columns={tableColConfig}
      isSubTable={true}
      showSelect={false}
      showPagination={false}
    />
  );
}
